import { useMemo } from 'react';

import { Route, Switch, useLocation } from 'react-router-dom';

import { FormGrid } from 'components';
import { Navbar } from 'components/Navbar';
import { PrivateRoute } from 'components/PrivateRoute';
import { TimeoutController } from 'components/TimeoutModal/TimeoutController';
import { ReviewedCandidateProvider } from 'contexts';
import { getReturnButtonPath } from 'helpers';
import { useUserContext } from 'hooks/useUserContext';
import { SystemAdminUserTable } from 'pages/dashboard/SystemAdminUserTable';
import { NotFound } from 'pages/error/NotFound';
import { PermissionDenied } from 'pages/error/PermissionDenied';
import { UserPage } from 'pages/user/UserPage';
import { UserProps } from 'types';

const createAuthChecks = (user: UserProps | null) => [
  {
    check: () => user?.role === 'system_admin',
    path: '/home/system_admin_dashboard/403',
  },
];

export const ContentWrapper = () => {
  const location = useLocation<{ from?: string }>();
  const { user, loaded } = useUserContext();
  const authChecks = useMemo(() => createAuthChecks(user), [user]);

  // This stops the auth checks in each route from firing before the user data is loaded
  if (!user && !loaded) {
    // Still loading
    return null;
  }

  return (
    <ReviewedCandidateProvider>
      <Navbar
        profile={false}
        links={[
          {
            path: '/home/system_admin_dashboard/users',
            label: 'Users',
          },
        ]}
      />
      <Switch>
        <PrivateRoute
          path='/home/system_admin_dashboard/users/:user_id'
          component={() => (
            <FormGrid
              path={getReturnButtonPath(
                '/home/system_admin_dashboard/users',
                location.state?.from,
              )}
              label='RETURN TO USERS'
            >
              <UserPage />
            </FormGrid>
          )}
          authChecks={authChecks}
        />
        <PrivateRoute
          path='/home/system_admin_dashboard/users'
          component={SystemAdminUserTable}
          authChecks={authChecks}
        />
        <Route
          path='/home/system_admin_dashboard/403'
          component={PermissionDenied}
        />
        <Route component={NotFound} />
      </Switch>
      <TimeoutController />
    </ReviewedCandidateProvider>
  );
};
